import { render, staticRenderFns } from "./PortalRequestDetailStep.vue?vue&type=template&id=d966abfa"
import script from "./PortalRequestDetailStep.vue?vue&type=script&lang=js"
export * from "./PortalRequestDetailStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports